export default __webpack_public_path__ + "static/media/america_exam.7613de5c.png";